import { useQuery } from '@tanstack/react-query';
import { Package } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function usePricelist(packageId) {
  return useQuery([QUERY_KEYS.PRICELIST, packageId], () => (
    Package
      .find(packageId)
      .then((res) => res.data)
  ), { enabled: !!packageId });
}
